import { SlotType } from './../SlotType';

export class PrefillSlot {
  constructor(
    private readonly id: number,
    private readonly name: string,
    private readonly description: string | null,
    private readonly slotType: SlotType,
    private readonly tags: string[]
  ) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getDescription() {
    return this.description;
  }

  getSlotType() {
    return this.slotType;
  }

  getTags() {
    return this.tags;
  }
}
